import http from 'plugins/axios';

export default {
    getList({page,size,robotId}){
      return http.get({
        url:  `/la/admin/robot/symbol/list?page=${page}&size=${size}&robotId=${robotId} `
      })
    },
    //获取交易对列表
    getPairData(){
      // return http.get({
      //   url:'/la/admin/symbol/fbsNames'
      // })
      return http.get({
        url:`/la/admin/robot/info/fbsPairList`,
        // data,
        // dataType: 'form'
    })
    },
    //修改
    updateOne(data){
      return http.post({
        url:'/la/admin/robot/symbol/update',
        data
      })
    },
    //添加
    addOne(data){
      return http.post({
        url:'/la/admin/robot/symbol/add',
        data
      })
    },
    delOne(id){
      return http.post({
        url:`/la/admin/robot/symbol/del?id=${id}`,
       
      })
    },
};
